import type { AuthUser } from '@/types/auth.types'
import { canAccessRoute, type RouteAccessId } from './uiAccess'

export type PlatformNavigationId =
  | 'business-review'
  | 'subject-review'
  | 'source-review'
  | 'identity-review'
  | 'policy'
  | 'overview'
  | 'tenants'
  | 'users'
  | 'monitoring'
  | 'operations'
  | 'support'
  | 'audit'
  | 'deletions'
  | 'profile'
  | 'settings'

export interface PlatformNavigationItem {
  id: PlatformNavigationId
  label: string
  path: string
  access: RouteAccessId
}

export const platformNavigation: PlatformNavigationItem[] = [
  { id: 'identity-review', label: 'Identity adjudication', path: '/platform/identity-reviews', access: 'platformIdentityReview' },
  {
    id: 'source-review',
    label: 'Source relationship reviews',
    path: '/platform/source-relationship-reviews',
    access: 'platformSubjectReview',
  },
  {
    id: 'business-review',
    label: 'Business appointment reviews',
    path: '/platform/business-legal-control-reviews',
    access: 'platformBusinessSubjectReview',
  },
  {
    id: 'subject-review',
    label: 'HUF appointment reviews',
    path: '/platform/legal-control-reviews',
    access: 'platformSubjectReview',
  },
  {
    id: 'policy',
    label: 'Legal control policies',
    path: '/platform/legal-control-policies',
    access: 'platformPolicyGovernance',
  },
  { id: 'overview', label: 'Overview', path: '/platform', access: 'platformOverview' },
  { id: 'tenants', label: 'Tenants', path: '/platform/tenants', access: 'platformTenants' },
  { id: 'users', label: 'Users', path: '/platform/users', access: 'platformUsers' },
  {
    id: 'monitoring',
    label: 'Monitoring',
    path: '/platform/monitoring',
    access: 'platformMonitoring',
  },
  {
    id: 'operations',
    label: 'Operations',
    path: '/platform/operations',
    access: 'platformOperations',
  },
  {
    id: 'support',
    label: 'Tenant Support',
    path: '/platform/support-sessions',
    access: 'platformSupport',
  },
  { id: 'audit', label: 'Audit', path: '/platform/audit', access: 'platformAudit' },
  {
    id: 'deletions',
    label: 'Deletion Governance',
    path: '/platform/deletions',
    access: 'platformDeletions',
  },
  { id: 'profile', label: 'My Profile', path: '/platform/profile', access: 'platformProfile' },
  { id: 'settings', label: 'Settings', path: '/platform/settings', access: 'platformSettings' },
]

export function buildPlatformNavigation(
  user: Pick<AuthUser, 'role' | 'permissions' | 'features'> | null | undefined
): PlatformNavigationItem[] {
  return platformNavigation.filter(item => canAccessRoute(user, item.access))
}
